import { atom } from 'jotai';

import { DateGDT, Maybe } from '../types/index';
import { RecordsTda, StatiticsTda } from '../types/tda';

import { TabType } from './../components/Types';

import { DatosParticipanteMiniLigasTO } from '@/types/minileagues';
import { EnumContextGDT } from '@/types/team';

export interface ImageCover {
  id: number;
  src: string;
  color?: string;
}

export type InitialDataTourneys = {
  key?: EnumContextGDT;
  id: number;
  inscriptionOpen?: boolean;
  isVip: boolean;
  isOwner: boolean;
  idOwner: Maybe<number>;
  tourney: any;
  tourneyStarted: boolean;
  maxNumParticipants: number;
  tourneysPlaying: any[];
  tourneysPending: any[];
  tourneysInvitations: any[];
  idsPendings: number[];
  idsPlayings: number[];
  rankingAvailable: DateGDT[];
  pendingInvitations: number;
  initDay?: number | null;
  matchDay: DateGDT | null;
  mainTab: TabType;
  subMainTab: TabType;
  showModalInfo?: boolean;
  showModalCover?: boolean;
  showModalError?: {
    visible: boolean;
    id: number;
  } | null;
  showImageModalFromFile?: boolean;
  selectedCoverDefault?: ImageCover;
  selectedCoverFromFile?: HTMLInputElement;
  selectedSourceImageCover?: string;
  selectedCover?: { id?: number; url?: string };
  records?: RecordsTda;
  statitics?: StatiticsTda;
  tourneyPlayers?: any[];
  tourneyGuests?: any[];
  tourneyPendings?: any[];
  minileagueMembers?: DatosParticipanteMiniLigasTO[];
  minileagueInvited?: DatosParticipanteMiniLigasTO[];
  minileaguePartPending?: DatosParticipanteMiniLigasTO[];
  tourneyPrice?: number;
  tourneyPinPrice?: number;
};

export const initialDataTourneys: InitialDataTourneys = {
  id: 0,
  inscriptionOpen: false,
  isVip: false,
  isOwner: false,
  idOwner: null,
  tourney: null,
  tourneyStarted: false,
  maxNumParticipants: 0,
  tourneysPlaying: [],
  tourneysPending: [],
  tourneysInvitations: [],
  idsPendings: [],
  idsPlayings: [],
  rankingAvailable: [],
  pendingInvitations: 0,
  initDay: null,
  mainTab: TabType.FirstTab,
  subMainTab: TabType.FirstTab,
  matchDay: null,
  showModalInfo: false,
  showModalCover: false,
  showModalError: null,
  showImageModalFromFile: false,
  selectedCoverDefault: undefined,
  selectedCoverFromFile: undefined,
  selectedSourceImageCover: undefined,
  records: undefined,
  statitics: undefined,
  selectedCover: { id: undefined, url: undefined },
};

export const tourneyAtom = atom<InitialDataTourneys>(initialDataTourneys);
